import _Comment from './Comment';

import './style/index.js';

export * from './type';

export const Comment = _Comment;

export default Comment;
